/* ============================================================
   SONICSTICKS · CART DRAWER v10 · SKRYPT
   Wyniesiony z sections/footer-group.json. Konfiguracja przychodzi
   z window.SS_CART_CFG (ustawiana w custom_liquid, bo potrzebuje Liquid).

   Zmiany wzgledem v9:
   1. Koniec petli odpytywania /cart.js. paint() pisze do DOM tylko wtedy,
      gdy wartosc sie zmienia, a obserwator DOM ignoruje mutacje wewnatrz
      elementow, ktore sam wstrzykuje. Do tego sync() jest debounce'owany.
   2. Kolejnosc odpowiedzi. Kazde odswiezenie ma numer (seq). Odpowiedz
      starsza niz ostatnie zadanie jest odrzucana, wiec suma nie moze
      cofnac sie do starego stanu po wolnym pakiecie na telefonie.
   3. Wiersz Ochrony w liscie rozpoznawany po ID wariantu (najpewniej),
      potem po linku, na koncu po nazwie. Zmiana tytulu produktu w adminie
      nie odslania juz wiersza.
   4. Klasa is-empty na <cart-drawer> wynika z zawartosci koszyka. Sekcje
      dodajace do koszyka wlasnym skryptem (np. zestawy na stronie glownej)
      omijaja render Shrine i zostawialy szuflade w ukladzie "pusty".
   5. Drugie wyjscie z koszyka: link "Kontynuuj zakupy" pod CTA. Gorny X
      jest teraz podpisana pigulka (styl w ss-cart.css).
   Ochrona przesylki startuje WYLACZONA (art. 10 u.p.k.): stan przelacznika
   wynika wylacznie z zawartosci koszyka, nigdy z ustawienia domyslnego.
   ============================================================ */
(function () {
  'use strict';

  var CFG = window.SS_CART_CFG || {};
  CFG.handle = CFG.handle || 'ubezpieczenie-przesylki';
  CFG.title = CFG.title || 'Ochrona przesyłki';
  CFG.priceLabel = CFG.priceLabel || '4,99 zł';
  CFG.productUrl = CFG.productUrl || '/products/sonicsticks';
  CFG.logo = CFG.logo || '';

  var variantId = null, pending = null, desired = null, mutating = false, bound = false, raf = false;
  var seq = 0, syncTimer = null;
  var OWN = '#ss-insurance, #ss-summary, #ss-secure, #ss-help, #ss-back, #ss-empty, #ss-error, .drawer__heading';

  function d(){ return document.querySelector('cart-drawer'); }
  function q(s, r){ return (r || document).querySelector(s); }
  function money(c){ return (c / 100).toFixed(2).replace('.', ',') + ' zł'; }
  function setText(el, v){ if (el && el.textContent !== v) el.textContent = v; }

  function loadProduct(){
    if (variantId) return Promise.resolve();
    return fetch('/products/' + CFG.handle + '.js')
      .then(function(r){ if(!r.ok) throw new Error('no-product'); return r.json(); })
      .then(function(p){ variantId = p.variants[0].id; })
      .catch(function(){ console.warn('[SS] brak produktu ' + CFG.handle); });
  }

  function setEmptyState(cart){
    var el = d();
    if (!el || !cart) return;
    var empty = !cart.items || cart.items.length === 0;
    if (el.classList.contains('is-empty') !== empty){
      mutating = true;
      el.classList.toggle('is-empty', empty);
      mutating = false;
    }
  }

  function closeDrawer(){
    var el = d();
    if (!el) return;
    if (typeof el.close === 'function') el.close();
    else {
      el.classList.remove('active');
      el.setAttribute('aria-hidden', 'true');
    }
    document.body.classList.remove('overflow-hidden');
  }

  function injectHeader(cart){
    var head = q('cart-drawer .drawer__heading');
    if (!head) return;
    var n = 0;
    if (cart && cart.items) cart.items.forEach(function(i){ if (i.handle !== CFG.handle) n += i.quantity; });
    var html = 'Twój koszyk' + (n > 0 ? ' <span class="ss-cart-badge">' + n + '</span>' : '');
    if (head.innerHTML !== html) head.innerHTML = html;
  }

  function injectInsurance(){
    if (document.getElementById('ss-insurance')) return;
    var footer = q('cart-drawer .drawer__footer');
    if (!footer) return;
    var el = document.createElement('div');
    el.id = 'ss-insurance';
    el.innerHTML =
      '<div class="ss-ins-left">' +
        '<span class="ss-ins-icon-wrap">' +
          '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<path d="M12 22s8-3.5 8-10V5l-8-3-8 3v7c0 6.5 8 10 8 10z"/><path d="M9 11.5l2 2 4-4.5"/>' +
          '</svg>' +
        '</span>' +
        '<div>' +
          '<p class="ss-ins-title">Ochrona przesyłki</p>' +
          '<p class="ss-ins-desc">Wzmocnione pakowanie i szybsze rozliczenie.</p>' +
        '</div>' +
      '</div>' +
      '<div class="ss-ins-right">' +
        '<span class="ss-ins-price">' + CFG.priceLabel + '</span>' +
        '<label class="ss-switch">' +
          '<input type="checkbox" id="ss-ins-toggle" aria-label="Dodaj ochronę przesyłki za ' + CFG.priceLabel + '">' +
          '<span class="ss-slider"></span>' +
        '</label>' +
      '</div>';
    footer.prepend(el);
    var err = document.createElement('div');
    err.id = 'ss-error';
    footer.prepend(err);
  }

  function injectSummary(){
    if (document.getElementById('ss-summary')) return;
    var ins = document.getElementById('ss-insurance');
    if (!ins) return;
    var box = document.createElement('div');
    box.id = 'ss-summary';
    box.innerHTML =
      '<div class="ss-sum-row" id="ss-sum-items"><span>Produkty</span><span>—</span></div>' +
      '<div class="ss-sum-row" id="ss-sum-ins" hidden><span>Ochrona przesyłki</span><span>' + CFG.priceLabel + '</span></div>' +
      '<div class="ss-sum-row ss-sum-row--muted"><span>Dostawa</span><span>obliczana przy finalizacji</span></div>' +
      '<div class="ss-sum-total"><b>Razem</b><strong id="ss-sum-total">—</strong></div>';
    ins.insertAdjacentElement('afterend', box);
  }

  function injectSecure(){
    if (document.getElementById('ss-secure')) return;
    var ctas = q('cart-drawer .cart__ctas');
    if (!ctas) return;
    var box = document.createElement('div');
    box.id = 'ss-secure';
    box.innerHTML =
      '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<rect x="4" y="11" width="16" height="10" rx="2.5"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/>' +
      '</svg>' +
      '<div><p class="ss-secure-title">Bezpieczne i szyfrowane płatności</p>' +
      '<p class="ss-secure-desc">Twoje dane płatnicze są chronione.</p></div>';
    ctas.insertAdjacentElement('afterend', box);
    var help = document.createElement('p');
    help.id = 'ss-help';
    help.innerHTML = 'Pytania? <a href="mailto:kontakt@sonicsticks.pl">kontakt@sonicsticks.pl</a> · pon–pt 10:00–18:00<br>' +
      '<a href="/policies/shipping-policy">Dostawa</a> · <a href="/policies/refund-policy">Zwroty</a>';
    box.insertAdjacentElement('afterend', help);
  }

  function injectBack(){
    if (document.getElementById('ss-back')) return;
    var secure = document.getElementById('ss-secure');
    if (!secure) return;
    var b = document.createElement('button');
    b.id = 'ss-back';
    b.type = 'button';
    b.textContent = 'Kontynuuj zakupy';
    b.addEventListener('click', closeDrawer);
    secure.insertAdjacentElement('beforebegin', b);
  }

  function injectEmpty(){
    var wrap = q('cart-drawer .cart-drawer__empty-content');
    if (!wrap || document.getElementById('ss-empty')) return;
    var el = document.createElement('div');
    el.id = 'ss-empty';
    el.innerHTML =
      '<div id="ss-empty-art"><img src="' + CFG.logo + '" alt="" loading="lazy"></div>' +
      '<h3>Twój koszyk jest pusty</h3>' +
      '<p>Wybierz swój zestaw SonicSticks i wróć tutaj, żeby dokończyć zamówienie.</p>' +
      '<a class="ss-empty-cta" href="' + CFG.productUrl + '">Wybierz zestaw</a>';
    wrap.prepend(el);
  }

  function isInsRow(row){
    if (variantId){
      var vid = String(variantId);
      var byVariant = row.querySelector('[data-quantity-variant-id="' + vid + '"], [data-variant-id="' + vid + '"]');
      if (byVariant) return true;
      var inp = row.querySelector('input[name^="updates"]');
      if (inp && inp.getAttribute('data-quantity-variant-id') === vid) return true;
    }
    if (row.querySelector('a[href*="' + CFG.handle + '"]')) return true;
    var nameEl = row.querySelector('.cart-item__name');
    return !!(nameEl && nameEl.textContent.trim().indexOf(CFG.title) === 0);
  }
  function markRows(){
    document.querySelectorAll('cart-drawer .cart-item').forEach(function(row){
      var on = isInsRow(row);
      if (row.classList.contains('ss-ins-row') !== on) row.classList.toggle('ss-ins-row', on);
    });
  }

  function showError(msg){
    var e = document.getElementById('ss-error');
    if (!e) return;
    e.textContent = msg; e.classList.add('is-on');
    setTimeout(function(){ e.classList.remove('is-on'); }, 6000);
  }
  function busy(on){
    var f = q('cart-drawer .drawer__footer');
    if (f) f.classList.toggle('ss-busy', !!on);
  }

  function paint(cart){
    if (!cart || !cart.items) return;
    var line = null, itemsTotal = 0;
    cart.items.forEach(function(i){
      if (i.handle === CFG.handle) line = i; else itemsTotal += i.final_line_price;
    });
    setEmptyState(cart);
    mutating = true;
    injectHeader(cart);
    var t = document.getElementById('ss-ins-toggle');
    if (t && t.checked !== !!line) t.checked = !!line;
    var si = document.getElementById('ss-sum-items');
    if (si) setText(si.lastElementChild, money(itemsTotal));
    var sn = document.getElementById('ss-sum-ins');
    if (sn && sn.hidden !== !line) sn.hidden = !line;
    setText(document.getElementById('ss-sum-total'), money(cart.total_price));
    var btn = document.getElementById('CartDrawer-Checkout');
    if (btn) btn.disabled = cart.items.length === 0;
    markRows();
    mutating = false;
  }

  function getCart(){
    return fetch('/cart.js', { cache: 'no-store' }).then(function(r){ return r.json(); });
  }

  function refresh(cart){
    var my = ++seq;
    var p = (cart && cart.items) ? Promise.resolve(cart) : getCart();
    return p.then(function(c){
      if (my !== seq) return;
      paint(c);
      return fetch(window.location.pathname + '?sections=cart-drawer', { cache: 'no-store' })
        .then(function(r){ return r.json(); })
        .then(function(sec){
          if (my !== seq || !sec['cart-drawer']) return;
          var doc = new DOMParser().parseFromString(sec['cart-drawer'], 'text/html');
          mutating = true;
          var fresh = doc.querySelector('#CartDrawer-CartItems');
          var cur = document.getElementById('CartDrawer-CartItems');
          if (fresh && cur) cur.innerHTML = fresh.innerHTML;
          mutating = false;
          paint(c);
        })
        .catch(function(){ mutating = false; });
    });
  }

  function findLine(cart){
    for (var i = 0; i < cart.items.length; i++){
      if (cart.items[i].handle === CFG.handle) return cart.items[i];
    }
    return null;
  }
  function changeLine(key, qty){
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function(r){ return r.json().then(function(x){ if(!r.ok) throw new Error(x.description || 'change'); return x; }); });
  }
  function setInsurance(on){
    return getCart().then(function(cart){
      var line = findLine(cart);
      if (on){
        if (line && line.quantity === 1) return cart;
        if (line) return changeLine(line.key, 1);
        return fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        }).then(function(r){ return r.json().then(function(x){ if(!r.ok) throw new Error(x.description || x.message || 'add'); return x; }); })
          .then(getCart);
      }
      if (line) return changeLine(line.key, 0);
      return cart;
    });
  }

  function onToggle(e){
    if (mutating) return;
    desired = e.target.checked;
    if (pending) return;
    run();
  }
  function run(){
    var target = desired;
    if (target === null) return;
    busy(true);
    seq++;
    pending = loadProduct()
      .then(function(){ if (!variantId) throw new Error('no-variant'); return setInsurance(target); })
      .then(refresh)
      .then(function(){
        pending = null; busy(false);
        if (desired !== target) run(); else desired = null;
      })
      .catch(function(err){
        pending = null; desired = null; busy(false);
        showError('Nie udało się zaktualizować koszyka. Spróbuj ponownie.');
        var t = document.getElementById('ss-ins-toggle');
        if (t){ mutating = true; t.checked = !target; mutating = false; }
        console.warn('[SS] toggle:', err.message);
      });
  }

  function sync(){
    if (pending) return;
    var my = ++seq;
    getCart().then(function(cart){
      if (pending || my !== seq) return;
      var line = findLine(cart);
      var real = cart.items.filter(function(i){ return i.handle !== CFG.handle; });
      paint(cart);
      if (line && real.length === 0){
        pending = changeLine(line.key, 0).then(refresh).then(function(){ pending = null; }).catch(function(){ pending = null; });
        return;
      }
      if (line && line.quantity > 1){
        pending = changeLine(line.key, 1).then(refresh).then(function(){ pending = null; }).catch(function(){ pending = null; });
      }
    }).catch(function(){});
  }
  function syncSoon(){
    clearTimeout(syncTimer);
    syncTimer = setTimeout(sync, 250);
  }

  function injectAll(withSync){
    mutating = true;
    injectInsurance();
    injectSummary();
    injectSecure();
    injectBack();
    injectEmpty();
    markRows();
    mutating = false;
    if (withSync !== false) syncSoon();
  }
  function schedule(){
    if (raf) return;
    raf = true;
    requestAnimationFrame(function(){ raf = false; injectAll(); });
  }
  function isOwn(node){
    var el = node.nodeType === 1 ? node : node.parentElement;
    return !!(el && el.closest && el.closest(OWN));
  }
  function watch(){
    var el = d();
    if (!el) return;
    new MutationObserver(function(){ if (!mutating && el.classList.contains('active')) injectAll(); })
      .observe(el, { attributes: true, attributeFilter: ['class'] });
    new MutationObserver(function(list){
      if (pending || mutating) return;
      for (var i = 0; i < list.length; i++){
        if (!isOwn(list[i].target)){ schedule(); return; }
      }
    }).observe(el, { childList: true, subtree: true });
  }
  function bind(){
    if (bound) return;
    bound = true;
    document.addEventListener('change', function(e){
      if (e.target && e.target.id === 'ss-ins-toggle') onToggle(e);
    });
  }
  function init(){
    if (!d()) return;
    bind();
    watch();
    loadProduct().then(function(){ injectAll(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
